import React from 'react';
export const useSafeImage = (image) => {
    const [urlImage, setUrlImage] = React.useState(image?.image);
    // Added useEffect to avoid problems with SSR (Server-Side Rendering)
    React.useEffect(() => {
        // Preload the image to handle fallback if it fails to load
        const img = new Image();
        img.src = image?.image || '';
        img.onerror = () => setUrlImage(image?.fallbackImage);
        return () => {
            // Cleanup if necessary
            img.onerror = null;
        };
    }, [image?.image, image?.fallbackImage]);
    return urlImage;
};
//# sourceMappingURL=useSafeImage.js.map